<template>
  <div class="usesafely">
    <van-sticky>
      <vannav></vannav>
    </van-sticky>

    <div class="ban">
      <div>
        <p>{{ dayEnergy }}</p>
        <p>昨日能耗(kwh)</p>
      </div>
      <div>
        <p>{{ monthEnergy }}</p>
        <p>本月能耗(kwh)</p>
      </div>
      <div>
        <p>{{ yearEnergy }}</p>
        <p>总能耗(kwh)</p>
      </div>
    </div>
    <!-- <div class="ban1">
			<div @click="toTemp">
				<i class="iconfont icon-wendujiankong"></i>
				<p>温度监控</p>
			</div>
			<div @click="$router.push('/leakage')">
				<i class="iconfont icon-loudianbaohu"></i>
				<p>漏电电流</p>
			</div>
		</div> -->
    <div class="box tabs">
      <van-tabs
        color="rgba(70, 122, 255, 1) "
        title-active-color="rgba(70, 122, 255, 1) "
        title-inactive-color="rgba(35, 39, 38, 0.4000) "
        @click="draw"
      >
        <van-tab title="各类事件统计"></van-tab>
        <van-tab title="负载总功率"></van-tab>
      </van-tabs>
    </div>
    <div v-show="draweview === true" class="echartsbox">
      <div id="echar" class="ech" style="height: 230px"></div>
    </div>
    <div v-show="draweview1 === true" class="echartsbox">
      <div id="echar1" class="ech" style="width: 100vw; height: 230px"></div>
    </div>
    <div class="box newBar">
      <boxtop :calsstop="calsstop1">
        <span @click="toDetail()"
          >更多
          <img :src="require('../assets/home/right.png')" alt="" />
        </span>
      </boxtop>
    </div>
    <div class="usesafelytext">
      <textbox
        :datalist="datalist"
        :pendingList="pendingList"
        :processedList="processedList"
        :untreatedList="untreatedList"
      ></textbox>
    </div>
  </div>
</template>

<script>
import {
  eventStatistics,
  selectLineP,
  selectWarnLogPage,
} from "@/api/usesafely";

export default {
  data() {
    return {
      draweview: true,
      draweview1: false,

      calsstop1: {
        title: "事件概况",
      },
      option: {
        grid: {
          top: "22%",
          bottom: "20%",
          right: "10%",
          left: "10%",
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
        },
        xAxis: {
          type: "category",
          data: [],
        },
        legend: {
          show: false,
          data: ["各类事件"],
          icon: "circle",
          padding: [20, 30],
        },
        yAxis: {
          type: "value",
          name: "(件数)",
        },
        series: [
          {
            name: "各类事件",
            data: [],
            type: "bar",
            smooth: true,

            backgroundStyle: {
              color: "rgba(180, 180, 180, 0.2)",
            },
            itemStyle: {
              normal: {
                color: "#2b94fe",
                lineStyle: {
                  color: "#2b94fe",
                },
              },
            },
          },
        ],
      },
      option1: {
        grid: {
          top: "22%",
          bottom: "15%",
          right: "10%",
          left: "10%",
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
        },
        xAxis: {
          type: "category",
          data: [],
        },
        legend: {
          show: false,
          data: ["总功率"],
          icon: "circle",
          padding: [20, 30],
        },
        yAxis: {
          type: "value",
          name: "(kwh)",
        },
        series: [
          {
            name: "总功率",
            data: [],
            type: "line",
            smooth: true,
            symbol: "none",
            backgroundStyle: {
              color: "rgba(180, 180, 180, 0.2)",
            },
            itemStyle: {
              normal: {
                color: "#2b94fe",
                lineStyle: {
                  color: "#2b94fe",
                },
              },
            },
          },
        ],
      },
      //   为文本传递数据
      dayEnergy: null,
      monthEnergy: null,
      yearEnergy: null,
      datalist: [],

      untreatedList: [],
      pendingList: [],
      processedList: [],
    };
  },
  mounted() {
    this.getselectWarnLogPage();
    this.dayEnergy = Number(window.sessionStorage.getItem("dayEnergy")).toFixed(
      3
    );

    this.monthEnergy = Number(
      window.sessionStorage.getItem("monthEnergy")
    ).toFixed(3);

    this.yearEnergy = Number(
      window.sessionStorage.getItem("yearEnergy")
    ).toFixed(3);
  },
  methods: {
    // 事件概况和负载总功率
    getselectWarnLogPage() {
      selectWarnLogPage(this.$token, 1, 10, 1)
        .then((res) => {
          if (res.data.code === 200) {
            this.datalist = res.data.data.records;
            console.log(this.datalist);
            this.untreatedList = [];
            this.pendingList = [];
            this.processedList = [];
            this.datalist.map((item) => {
              if (item.status === 1) {
                //已处理
                this.processedList.push(item);
              }
              if (item.status === 2) {
                //待处理
                this.pendingList.push(item);
              }
              if (item.status === 0) {
                //未处理
                this.untreatedList.push(item);
              }
              // this.$refs.tabs.resize();
            });
            console.log(this.processedList);
          } else {
            this.warnList = [];
            this.untreatedList = [];
            this.pendingList = [];
            this.processedList = [];
          }
        })
        .catch(() => {});

      selectLineP(this.$token).then((res) => {
        if (res.data.code == 200) {
          if (Object.keys(res.data.data).length === 0) {
            for (let i = 0; i < 24; i++) {
              if (i < 10) i = "0" + i;
              this.option1.xAxis.data.push(i + "h");
            }
            this.safelyEchart("echar1", this.option1);
            return;
          }
          res.data.data.sort((a, b) => {
            return a.lHour - b.lHour;
          });
          console.log(res);
          res.data.data.map((item) => {
            this.option1.series[0].data.push(item.lineP);
          });
          for (let i = 0; i < 24; i++) {
            if (i < 10) i = "0" + i;
            this.option1.xAxis.data.push(i + "h");
          }
          this.safelyEchart("echar1", this.option1);
        }
      });
      eventStatistics(this.$token).then((res) => {
        if (res.data.code == 200) {
          if (res.data.data.length === 0) {
            this.option.xAxis.data = [
              "短路",
              "过压",
              "过载",
              "欠压",
              "温度",
              "漏电",
            ];
          }
          res.data.data.map((item) => {
            this.option.xAxis.data.push(item.title);
            this.option.series[0].data.push(item.num);
          });
          this.safelyEchart("echar", this.option);
        }
      });
    },
    draw(name) {
      if (name == 0) {
        this.draweview = true;
        this.draweview1 = false;
        this.safelyEchart("echar", this.option);
      } else if (name == 1) {
        this.draweview1 = true;
        this.draweview = false;
        this.safelyEchart("echar1", this.option1);
      }
    },
    /**
     * id:获取对象
     * Chart：初始化
     * option：配置信息
     */
    safelyEchart(id, option) {
      var myChart = this.$echarts.init(document.getElementById(id));
      myChart.setOption(option);
      window.onresize = function () {
        myChart.resize();
      };
    },
    toDetail() {
      this.$router.push({
        path: "/safelyDetail",
        query: {
          warnItem: 1,
        },
      });
    },
    topower() {
      this.$router.push("/Inputpower");
    },
    toTemp() {
      this.$router.push("/temp");
    },
  },
};
</script>

<style lang="less" scoped>
.usesafely {
  background-color: #f4f6fa;
  // height: auto;
  width: 100%;

  .box {
    // width: 100%;
    box-sizing: border-box;
    background-color: #ffffff;
    display: flex;
    flex-direction: column;
  }

  .tabs {
    margin: auto;
  }

  .ban1,
  .ban {
    background-color: #ffffff;
    display: flex;
    justify-content: space-around;
    margin-bottom: 10px;
    color: #4e4e4e;
    height: 90px;
    border-bottom: 1px double #e7e7e7;

    & > div {
      flex: 1;
      background-color: #ffffff;
      line-height: 24px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;

      P:first-child {
        color: #0c0e28;
        font-weight: bold;
        font-size: 20px;
      }

      p:last-child {
        color: #c0c0c0;
        font-weight: normal;
        font-size: 13px;
      }

      & > i {
        font-size: 30px;
      }

      &:nth-child(2) {
        position: relative;

        &:before,
        &:after {
          content: "";
          background-color: #e7e3e3;
          width: 2px;
          height: 41%;
          position: absolute;
          left: 0;
          top: 31%;
        }

        &:after {
          left: 100%;
        }
      }
    }
  }

  .ban1 {
    font-size: 10px;
    color: #c2c2c2;
  }

  .usesafelytext {
    display: flex;
    justify-content: center;
    flex-direction: column;
  }

  .echartsbox {
    width: 100%;
    height: 220px;
    background-color: #ffffff;

    .ech {
      width: 100%;
      height: 100%;
      margin: auto;
    }
  }
}

.newBar {
  span {
    margin-top: 5px;
    color: #b5b5b5;
    cursor: pointer;

    & > img {
      width: 0.3rem;
      height: 0.3rem;
    }
  }
}
</style>
